/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SingleTurnChatLanguageEnum } from './SingleTurnChatLanguageEnum';
import {
  SingleTurnChatLanguageEnumFromJSON,
  SingleTurnChatLanguageEnumFromJSONTyped,
  SingleTurnChatLanguageEnumToJSON,
} from './SingleTurnChatLanguageEnum';
import type { SingleTurnChatGenerationKnowledgeBase } from './SingleTurnChatGenerationKnowledgeBase';
import {
  SingleTurnChatGenerationKnowledgeBaseFromJSON,
  SingleTurnChatGenerationKnowledgeBaseFromJSONTyped,
  SingleTurnChatGenerationKnowledgeBaseToJSON,
} from './SingleTurnChatGenerationKnowledgeBase';

/**
 *
 * @export
 * @interface SingleTurnChatGenerationInputs
 */
export interface SingleTurnChatGenerationInputs {
  /**
   *
   * @type {number}
   * @memberof SingleTurnChatGenerationInputs
   */
  readonly id: number;
  /**
   *
   * @type {SingleTurnChatGenerationKnowledgeBase}
   * @memberof SingleTurnChatGenerationInputs
   */
  knowledgeBase: SingleTurnChatGenerationKnowledgeBase;
  /**
   *
   * @type {string}
   * @memberof SingleTurnChatGenerationInputs
   */
  description?: string;
  /**
   *
   * @type {SingleTurnChatLanguageEnum}
   * @memberof SingleTurnChatGenerationInputs
   */
  language?: SingleTurnChatLanguageEnum;
  /**
   *
   * @type {any}
   * @memberof SingleTurnChatGenerationInputs
   */
  examples?: any | null;
  /**
   *
   * @type {string}
   * @memberof SingleTurnChatGenerationInputs
   */
  styleGuide?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof SingleTurnChatGenerationInputs
   */
  autoNSamples?: boolean;
  /**
   *
   * @type {number}
   * @memberof SingleTurnChatGenerationInputs
   */
  nSamples?: number | null;
  /**
   *
   * @type {number}
   * @memberof SingleTurnChatGenerationInputs
   */
  maxSamples?: number | null;
}

/**
 * Check if a given object implements the SingleTurnChatGenerationInputs interface.
 */
export function instanceOfSingleTurnChatGenerationInputs(value: object): value is SingleTurnChatGenerationInputs {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('knowledgeBase' in value) || value['knowledgeBase'] === undefined) return false;
  return true;
}

export function SingleTurnChatGenerationInputsFromJSON(json: any): SingleTurnChatGenerationInputs {
  return SingleTurnChatGenerationInputsFromJSONTyped(json, false);
}

export function SingleTurnChatGenerationInputsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SingleTurnChatGenerationInputs {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    knowledgeBase: SingleTurnChatGenerationKnowledgeBaseFromJSON(json['knowledge_base']),
    description: json['description'] == null ? undefined : json['description'],
    language: json['language'] == null ? undefined : SingleTurnChatLanguageEnumFromJSON(json['language']),
    examples: json['examples'] == null ? undefined : json['examples'],
    styleGuide: json['style_guide'] == null ? undefined : json['style_guide'],
    autoNSamples: json['auto_n_samples'] == null ? undefined : json['auto_n_samples'],
    nSamples: json['n_samples'] == null ? undefined : json['n_samples'],
    maxSamples: json['max_samples'] == null ? undefined : json['max_samples'],
  };
}

export function SingleTurnChatGenerationInputsToJSON(value?: Omit<SingleTurnChatGenerationInputs, 'id'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    knowledge_base: SingleTurnChatGenerationKnowledgeBaseToJSON(value['knowledgeBase']),
    description: value['description'],
    language: SingleTurnChatLanguageEnumToJSON(value['language']),
    examples: value['examples'],
    style_guide: value['styleGuide'],
    auto_n_samples: value['autoNSamples'],
    n_samples: value['nSamples'],
    max_samples: value['maxSamples'],
  };
}
